export class FieldOption {
  constructor(public readonly name: string, public readonly display: string, public readonly defaultValue: string = '') {}
}
